module.exports = __webpack_public_path__ + "static/cler-4fbc752cdf68ecc08bb0dba796c3902d.png";